<script setup lang="ts">

import { useRouter } from 'vue-router';
import BankingWrapper from '@/application/layouts/ContentWrapper/BankingWrapper.vue';
import { useTagManager } from '@demv_systems/feu-tag-manager';
import { TrackEventCategory } from '@/application/utils/tracking/events';

const router = useRouter();

function onOpenBudgetAnalysis() {
  useTagManager().push({ event: TrackEventCategory.BANKS_API, action: 'openBudgetAnalysis' });
  router.push({ path: '/banking/budget-analysis' });
}

async function onOpenProduct(e: CustomEvent) {
  const { category, bankAccessId, productId } = e.detail
  useTagManager().push({ event: TrackEventCategory.BANKS_API, action: 'openProduct' });
  if (category === 'DEPOT') {
    await router.push(`/banking/${bankAccessId}/depot/${productId}`);
  } else {
    await router.push(`/banking/${bankAccessId}/account/${productId}`);
  }
}

async function onAddBankAccess(e: CustomEvent) {
  useTagManager().push({ event: TrackEventCategory.BANKS_API, action: 'addBankAccess' });
  const { sessionLink } = e.detail;
  await router.push({ path: '/banking/regprotect', query: { sessionLink } });
}

async function onManageBankAccess() {
  useTagManager().push({ event: TrackEventCategory.BANKS_API, action: 'manageBankAccess' });
  await router.push({ path: '/banking/bam' });
}
</script>

<template>
  <BankingWrapper v-slot="{ token, onEmitError }">
    <!-- eslint-disable vue/v-on-event-hyphenation -->
    <ba-product-list
      :token="token"
      @openProduct="onOpenProduct"
      @openBudgetAnalysis="onOpenBudgetAnalysis"
      @emitError="(e) => onEmitError(e, 'ba-product-list')"
      @addBankAccess="onAddBankAccess"
      @manageBankAccess="onManageBankAccess"
    />
  </BankingWrapper>
</template>
